<div class="container">
  <div class="switch-container">
    <label class="switch">
      <input
        type="checkbox"
        [id]="idCheckbox"
        [checked]="isChecked"
        (change)="toggleCheck()"
        ngDefaultControl
      />
      <span class="slider round"></span>
    </label>
  </div>
  <label
    class="description"
    [for]="idCheckbox"
    [style.color]="isChecked ? '#444' : '#ccc'"
  >
    <!-- {{ isChecked ? descriptionCheckBoxOff : descriptionCheckBoxOff }} -->
    {{ descriptionCheckBoxOff }}
  </label>
</div>
